/*
 * Fusion des lignes fantomes du panier (tiroir).
 *
 * Une reduction automatique "Achetez X, obtenez Y" tague une unite du produit
 * prerequis avec une remise de 0 EUR (titre "OFFERT" mais montant 0). Shopify
 * scinde alors ce produit en deux lignes plein tarif (ex : Produit X qty 3 +
 * Produit X qty 1). C'est un artefact d'affichage : aucune des deux lignes n'est
 * reellement remisee.
 *
 * Ce module refusionne ces lignes dans le tiroir : le produit prerequis
 * reapparait sur une seule ligne, et la remise ne reste visible que sur le vrai
 * produit offert (celui dont le prix passe a 0). Les modifications de quantite
 * et la suppression sur la ligne fusionnee sont routees par cle de ligne pour
 * rester coherentes avec le panier reel.
 */
(function () {
  'use strict';

  var MERGE_ATTR = 'data-merged-keys';
  var merging = false;

  function updateUrl() {
    return (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';
  }

  function drawerSections() {
    return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'].filter(function (id) {
      return document.getElementById(id);
    });
  }

  // Regroupe les lignes du tiroir par variant + prix unitaire, puis fusionne
  // tout groupe contenant une ligne fantome dans sa ligne principale.
  function mergeAll() {
    merging = true;

    var rows = Array.prototype.slice.call(document.querySelectorAll('.mu-ci[data-line-key]'));
    rows.forEach(function (row) {
      row.style.display = '';
      row.removeAttribute(MERGE_ATTR);
      row.removeAttribute('data-merged-total');
    });

    var groups = {};
    rows.forEach(function (row) {
      var key = row.getAttribute('data-variant-id') + '|' + row.getAttribute('data-unit-price');
      (groups[key] = groups[key] || []).push(row);
    });

    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      if (group.length < 2) return;
      var hasPhantom = group.some(function (row) { return row.getAttribute('data-phantom') === 'true'; });
      if (!hasPhantom) return;

      var primary = group.filter(function (row) { return row.getAttribute('data-phantom') !== 'true'; })[0] || group[0];
      var total = 0;
      var keys = [];
      group.forEach(function (row) {
        total += parseInt(row.getAttribute('data-quantity') || '0', 10);
        keys.push(row.getAttribute('data-line-key'));
      });

      var input = primary.querySelector('.quantity__input');
      if (input) input.value = total;

      primary.setAttribute(MERGE_ATTR, JSON.stringify(keys));
      primary.setAttribute('data-merged-total', String(total));

      group.forEach(function (row) {
        if (row !== primary) row.style.display = 'none';
      });
    });

    merging = false;
  }

  // Applique une quantite totale au groupe fusionne : la ligne principale recoit
  // le total, les lignes fantomes sont mises a 0 (Shopify recalcule la remise).
  function setGroupQuantity(keys, primaryKey, total) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = (k === primaryKey) ? total : 0; });

    var sections = drawerSections();

    fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state && state.sections) {
          sections.forEach(function (id) {
            var host = document.getElementById(id);
            if (!host || !state.sections[id]) return;
            var parsed = new DOMParser().parseFromString(state.sections[id], 'text/html').querySelector('.shopify-section');
            if (parsed) host.innerHTML = parsed.innerHTML;
          });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
      })
      .catch(function (error) { console.error('cart-gift-merge:', error); });
  }

  function mergedRow(target) {
    return target.closest ? target.closest('[' + MERGE_ATTR + ']') : null;
  }

  // Interception en phase de capture pour preempter les gestionnaires natifs du theme.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[name="plus"], button[name="minus"]');
    if (button) {
      var row = mergedRow(button);
      if (!row) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var keys = JSON.parse(row.getAttribute(MERGE_ATTR));
      var current = parseInt(row.getAttribute('data-merged-total') || '0', 10);
      var next = button.name === 'plus' ? current + 1 : current - 1;
      if (next < 0) next = 0;
      setGroupQuantity(keys, row.getAttribute('data-line-key'), next);
      return;
    }

    var remove = event.target.closest && event.target.closest('cart-remove-button, .mu-ci__remove');
    if (remove) {
      var removeRow = mergedRow(remove);
      if (!removeRow) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      setGroupQuantity(JSON.parse(removeRow.getAttribute(MERGE_ATTR)), removeRow.getAttribute('data-line-key'), 0);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('.quantity__input');
    if (!input) return;
    var row = mergedRow(input);
    if (!row) return;
    event.stopImmediatePropagation();
    var next = parseInt(input.value || '0', 10);
    if (isNaN(next) || next < 0) next = 0;
    setGroupQuantity(JSON.parse(row.getAttribute(MERGE_ATTR)), row.getAttribute('data-line-key'), next);
  }, true);

  document.addEventListener('cart:updated', function () { if (!merging) mergeAll(); });
  document.addEventListener('cartdrawer:opened', function () { if (!merging) mergeAll(); });

  // Le contenu du tiroir est injecte apres coup (add to cart, ajax) : on observe
  // les remplacements de contenu pour refusionner. Seuls les childList declenchent
  // le rappel, donc masquer une ligne (attribut style) ne cree pas de boucle.
  function observe(node) {
    if (!node) return;
    new MutationObserver(function () { if (!merging) mergeAll(); }).observe(node, { childList: true, subtree: true });
  }

  function init() {
    observe(document.getElementById('mini-cart'));
    mergeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
